module.exports = __webpack_public_path__ + "static/image/history/pc/202507.ver2_0_2.png?cfc8859e";